<script>
  import { onMount } from "svelte";
  import { WEB_ADSENCE_ID,WEB_SHOW_ADSENCE, WEB_SQUARE_SLOT_ID, WEB_CROSSWISE_SLOT_ID }from "$env/static/public";
  export let type = 'square';
  let slotId = ''
  switch(type) {
    case 'square':
      slotId = WEB_SQUARE_SLOT_ID;
      break;
    case 'crosswise':
      slotId = WEB_CROSSWISE_SLOT_ID;
      break;
    default:
      slotId = WEB_SQUARE_SLOT_ID;
  }
  export let client = "ca-pub-" + WEB_ADSENCE_ID; // 替换为你的AdSense ID
  export let adStyle = "display:block";
  let adLoaded = false;

  onMount(() => {
    // 避免SSR问题
    if (typeof window === "undefined" || WEB_SHOW_ADSENCE === 'false') return;

    // 加载AdSense主脚本（仅加载一次）
    if (!window.adsbygoogle) {
      const script = document.createElement("script");
      script.async = true;
      script.src =
        "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=" +
        client;
      script.crossOrigin = "anonymous";
      document.head.appendChild(script);

      // 等待脚本加载完成
      script.onload = () => {
        loadAd();
      };
    } else {
      loadAd();
    }

    function loadAd() {
      try {
        adLoaded = true;
        setTimeout(() => {
          // 触发广告加载
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        });
      } catch (e) {
        console.error(e);
      }
    }
  });
</script>

<div>
  {#if adLoaded}
    <ins
      class="adsbygoogle"
      style={adStyle}
      data-ad-client={client}
      data-ad-slot={slotId}
      data-ad-format="auto"
      data-full-width-responsive="true"
    >
    </ins>
  {/if}
</div>

<style>
  .adsbygoogle {
    
  }
</style>
